'use strict';

window.ID_MAP_GLEBA = 'map_gleba';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').factory('GlebasService', function($http, $q, GoogleMapsService) {
  return {
    list: function(filters) {
      filters = filters || {};
      return $http.get(`${SERVER}${API_VERSION}glebas`, {
        params: {
          propriedade: filters.propriedade,
          status: filters.status
        }
      });
    },

    get: function(id) {
      return $http.get(`${SERVER}${API_VERSION}glebas/${ id}`);
    },

    simplify: function(id) {
      return $http.post(`${SERVER}${API_VERSION}glebas/${ id }/simplify`);
    },

    inactivate: function(id) {
      return $http.post(`${SERVER}${API_VERSION}glebas/${ id }/inactivate`);
    },

    activate: function(id) {
      return $http.post(`${SERVER}${API_VERSION}glebas/${ id }/activate`);
    },

    save: function(gleba) {
      return $http({
        method: gleba.id ? 'PATCH' : 'POST',
        headers: { 'Content-Type': 'application/json' },
        url: `${SERVER}${API_VERSION}glebas/${ gleba.id || ''}`,
        data: { gleba: gleba }
      });
    },

    getMapGleba: function(idContainer, gleba) {
      const deferred = $q.defer();

      const propriedadeGleba = {
        glebas: [gleba]
      };

      GoogleMapsService.createMapForPropriedade(idContainer, propriedadeGleba).then(function(result) {
        deferred.resolve(result);
      });

      return deferred.promise;
    },

    getCoordinatesFromKmlFile: function(kml) {
      const params = {
        kml_content: kml
      };

      return $http.post(`${SERVER + API_VERSION }mapa/coordinates`, { params: params });
    }
  };
});
